import { RequestMessageHeader } from "@westpierstudio/core-module-oryx/services/comms/types/BaseTypes";
import { GameEvent, GameRequest } from "./ServerEvents";
import { SpinGamePlayData } from "./gameevents/InitialSpin";
import { FreeSpinGamePlayData } from "./gameevents/FreeSpin";
import { FREE_ROUND } from "./gameevents/OpenGame";

type GamePlayData = SpinGamePlayData | FreeSpinGamePlayData;

export type LastEventData = Required<Omit<BaseGameEventData<GamePlayData>, "roundId">>;

export type LastEvent = {
    correlationSeqId: number,
    data: LastEventData,
    event: GameEvent,
    seqId: number
}

export type NetPosition = {
    bets: number,
    netProfit: number,
    wins: number
}

export type BaseGameEvent<TEvent, TData> = {
    header: RequestMessageHeader,
    body: {
        balance: number,
        balanceVersion: number,
        correlationSeqId: number,
        data: TData,
        elapsedTimeInMillis?: number
        event: TEvent,
        lastEvent?: LastEvent,
        netPosition?: NetPosition,
        lastRoundId?: string,
        seqId: number
    }
}

export interface BaseGameEventData<TGamePlayData> {
    accumulatedCoinsWon: number,
    accumulatedJackpotsMoneyWon: number,
    accumulatedMoneyWon: number,
    balanceAfterBetData: {
        balanceAfterBet: number,
        balanceAfterBetVersion: number
    },
    betData: BetData,
    buyInId: number,
    gameplay: TGamePlayData,
    isRoundFinished: boolean,
    nextActions?: GameRequest[]
    roundId: string,
    totalCoinsWon: number,
    totalMoneyWon: number,
    freeRounds?: FREE_ROUND
}

export type StartBonusData = {
    bonusSymbolsPositions: SymbolPos[],
    reels: ReelSetSymbols
}

export interface GameEventDataWithNextActions<TGamePlayData> extends BaseGameEventData<TGamePlayData> {
    nextActions: GameRequest[]
}

export type BetData = {
    coinSize: number,
    coinsPerBet: number,
    pickIndex: number | null,
    playerBet: number,
}

export enum CoreSymbolID {
    LO = `LO`,
    M1 = `M1`,
    M2 = `M2`,
    M3 = `M3`,
    M4 = `M4`,
    F6 = `F6`,
    F7 = `F7`,
    F8 = `F8`,
    F9 = `F9`,
    FA = `FA`
}

export enum BonusSymbolID {
    B1 = `B1`
}

export enum WildSymbolID {
    WX = `WX`,
    WY = `WY`
}

export type SymbolID = CoreSymbolID | BonusSymbolID | WildSymbolID;
export type ReelSymbols = [SymbolID, SymbolID, SymbolID, SymbolID];

export type ReelSetSymbols = [
    ReelSymbols,
    ReelSymbols,
    ReelSymbols,
    ReelSymbols,
    ReelSymbols
];

export type SymbolPos = {
    column: number,
    row: number
}

export type Win = {
    coinsWon: number,
    moneyWon: number,
    oakIndex: number,
    pattern: { column: number, row: number }[],
    symbol: SymbolID,
    usesWild: boolean,
    winIndex: number
}

export type FreeSpinsCounter = {
    additionalFreeSpins?: number,
    freeSpinsRemaining: number,
    freeSpinsTotal: number
}

export type OrientationSpec<T> = {
    portrait: T,
    landscape: T,
}